export const PRICING_ROUTES = [
  {
    path: 'pricing/edit',
    name: 'EditPricing',
    component: () => import('./views/EditPricing.vue'),
  },
]
